import React from "react";
import Modal from "./modal";

interface SecondaryButtonProps {
  label: string;
  onClick: () => void;
}

interface InformationModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  title?: string;
  secondaryButton?: SecondaryButtonProps | undefined;
}

const InformationModal: React.FC<InformationModalProps> = ({
  isOpen,
  onClose,
  message,
  title = "Information",
  secondaryButton
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="text-center">
        {/* Information Icon */}
        <div className="mx-auto mb-4 text-blue-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        
        {/* Title */}
        <h3 className="mb-4 text-xl font-medium text-gray-900">{title}</h3>
        
        {/* Message */}
        <p className="mb-6 text-gray-600">{message}</p>
        
        {/* Buttons */}
        <div className="flex justify-center space-x-4">
          {secondaryButton && (
            <button
              onClick={secondaryButton.onClick}
              className="bg-white text-blue-600 border border-blue-600 px-6 py-2 rounded-lg hover:bg-blue-50 transition-colors"
            >
              {secondaryButton.label}
            </button>
          )}
          <button
            onClick={onClose}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InformationModal; 